import { render, staticRenderFns } from "./AliasList.vue?vue&type=template&id=b185d9bc&scoped=true&"
import script from "./AliasList.vue?vue&type=script&lang=js&"
export * from "./AliasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b185d9bc",
  null
  
)

export default component.exports